'use strict';

/*global services*/
/*global isEmpty*/
/*global createObjectCallBack*/

function K2Location() {
  this.$container = null;
  this.confirmedLeavePage = false;
  this.internetConnectionManager = null;

  this.init();
}

K2Location.prototype = $.extend({}, {
  constructor: 'K2Location',

  registerCallbacks: function registerCallbacks() {
    var _this = this;

    $('body').on('click', '.location__button', function () {
      if (_this.$container.data('location_without_confirm')) {
        _this.navigateToLocation();
      } else {
        _this.openConfirmForm();
      }

      return false;
    });
  },

  //----------------------------------------------------------------------------

  openConfirmForm: function openConfirmForm() {
    var _this = this;

    var modal = services.get('modal');
    modal.empty().open({
      title: services.get('translator').trans('k2_location.leave_page'),
      saveBtnTitle: services.get('translator').trans('k2_location.confirm_leave_page'),
      height: 'auto',
      width: 'md',
      modalClass: 'location__confirm',
      submitCallBack: createObjectCallBack(_this, 'submitConfirmFrom'),
      form: true,
      keyboardClose: false,
      content: '<div class="location__confirm-content">' + services.get('translator').trans('k2_location.confirm_leave_page_help') + '</div>'
    });

    return _this;
  },

  submitConfirmFrom: function submitConfirmFrom() {
    var _this = this;

    var modal = services.get('modal');
    modal.close();

    if (!_this.internetConnectionManager || _this.internetConnectionManager.isOnline()) {
      _this.confirmedLeavePage = true;

      if (services.has('main-page-module')) {
        var mainModule = services.get('main-page-module');
        if ('beforeLeavePage' in mainModule) {
          mainModule.beforeLeavePage();
        }

        if ('onBeforeLeavePage' in mainModule) {
          mainModule.onBeforeLeavePage();
        }
      }

      _this.navigateToLocation();
    } else {
      _this.internetConnectionManager.viewOfflineWarning();
    }

    return _this;
  },

  navigateToLocation: function navigateToLocation() {
    var _this = this;

    var href = _this.$container.data('location_href');

    if (!isEmpty(href)) {
      window.location.href = href;
    } else {
      window.history.back();
    }

    return _this;
  },

  isConfirmedLeavePage: function isConfirmedLeavePage() {
    var _this = this;

    return _this.confirmedLeavePage;
  },

  //----------------------------------------------------------------------------

  init: function init() {
    var _this = this;

    _this.$container = $('.location__go-to, .location__go-back');

    if (!_this.$container.data('location_no_fixed_button')) {
      _this.$container.append('<div class="location__button location__button--fixed" ><span class="glyphicon glyphicon-chevron-left"></span></div>');
    }

    if (services.has('internet-connection-manager')) {
      _this.internetConnectionManager = services.get('internet-connection-manager');
    } else {
      services.get('notifications').logWarning('Internet connection manager is not loaded!');
    }

    _this.registerCallbacks();
    return _this;
  }
});
